import React, { useEffect, useState } from 'react';
import styles from './UpdateStudyConfiguration.module.css';
import { useParams, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext.tsx';
import Loader from '../loader/Loader.tsx';
import FieldLoader from '../fieldloader/FieldLoader.tsx';
import Modal from '../modal/Modal.tsx';
import PageHeader from '../pageheader/Pageheader.tsx';
import Dropdown from '../dropdown/Dropdown.tsx';
import { useToast } from '../toast/ToastProvider.tsx';
import SubmitLoader from '../submitloader/SubmitLoader.tsx'; 
import { 
  getStudyByStudyId, 
  getDefineDropdownValues, 
  getCDISCStandardDropdownValues,
  getCDISCStdVersionDropdownValues,
  getDropdownValues,
  getCTNameDropdownValues,
  getCTNameVersionDropdownValues,
  createStudyGroup,
  getStudygroupDetails,
  createStudy,
  updateStudy,
  deleteFile

} from '../../api/api.js';
import { useNavigate } from 'react-router-dom';
import PageLoader from '../pageloader/PageLoader.tsx';
import ErrorPage from '../errorpage/ErrorPage.tsx';
interface StudyFormData {
  selectStudy: DropdownOption | null;
  studyName: string;
  studyCode?: string;
  protocolId: string;
  studyDescription: string;
  status?: string;
  indication?: string;
  studyVersionId?: number;
  userName?: string;
  defineStandard: DropdownOption | null;
  cdiscStandard: DropdownOption | null;
  standardVersion: DropdownOption | null;
  medDRA: DropdownOption | null;
  whoDD: DropdownOption | null;
  snomed: DropdownOption | null;
  loinc: DropdownOption | null;
  unii: DropdownOption | null;
  ndfRtMedRt: DropdownOption | null;
  ctName: DropdownOption | null;
  ctVersion: DropdownOption | null;
  aCRF: any;
  supplementDocs: any[];
  attachments?: {
    acrfFile?: {
      studyFileId: number;
      fileName: string;
      fileType: string;
      status: string;
    };
    supportingFiles?: Array<{
      studyFileId: number;
      fileName: string;
      fileType: string;
      status: string;
      cdiscStandardVersion: string;
    }>;
  };
}

interface DropdownOption {
  id: number;
  referenceKey?: string;
  referenceValue?: string;
  versionCode?: string;
  versionDisplay?: string;
  name?: string;
  version?: string;
  packageName?: string;
  packageType?: string;
  label?: string;
}

interface StudyGroup

{ id : number;
  groupName:string;
  description:string;
  active:boolean;

}


const UpdateStudyConfiguration: React.FC = () => {
  const location = useLocation();
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const searchParams = new URLSearchParams(location.search);
  const studyId = searchParams.get('studyId');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [activeTab, setActiveTab] = useState<'select' | 'create'>('select');
    const showToast = useToast();
  // Dropdown options state
  const [defineOptions, setDefineOptions] = useState<DropdownOption[]>([]);
  const [cdiscOptions, setCdiscOptions] = useState<DropdownOption[]>([]);
  const [standardVersionOptions, setStandardVersionOptions] = useState<DropdownOption[]>([]);
  const [meddraOptions, setMeddraOptions] = useState<DropdownOption[]>([]);
  const [whoddOptions, setWhoddOptions] = useState<DropdownOption[]>([]);
  const [snomedOptions, setSnomedOptions] = useState<DropdownOption[]>([]);
    const [loincOptions, setLoincOptions] = useState<DropdownOption[]>([]);
    const [uniiOptions, setUniiOptions] = useState<DropdownOption[]>([]);
    const [ndfRtMedRtOptions, setNdfRtMedRtOptions] = useState<DropdownOption[]>([]);
  const [ctNameOptions, setCtNameOptions] = useState<DropdownOption[]>([]);
  const [ctVersionOptions, setCtVersionOptions] = useState<any[]>([]);
  

    const [formErrors, setFormErrors] = useState<Record<string, string>>({});
    const [hasFormChanged, setHasFormChanged] = useState(false);
    const [initialFormData, setInitialFormData] = useState<StudyFormData | null>(null);
  
  // Loading states for dropdowns
  const [isLoadingStandardVersions, setIsLoadingStandardVersions] = useState(false);
  const [isLoadingCTVersions, setIsLoadingCTVersions] = useState(false);
  

    const [fileToDelete, setFileToDelete] = useState<{
      type: 'aCRF' | 'supplementDocs';
      file: File | null;
      index?: number;
    } | null>(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [formData, setFormData] = useState<StudyFormData>({
    selectStudy: null,
    studyName: '',
    studyCode: '',
    protocolId: '',
    studyDescription: '',
    status: '',
    indication: '',
    studyVersionId: undefined,
    userName: '',
    defineStandard: null,
    cdiscStandard: null,
    standardVersion: null,
    medDRA: null,
    whoDD: null,
    snomed: null,
    loinc: null,
    unii: null,
    ndfRtMedRt: null,
    ctName: null,
    ctVersion: null,
    aCRF: null,
    supplementDocs: [],
  });

  const [studyGroups, setStudyGroups] = useState<StudyGroup[]>([]);
const [groupFormData, setGroupFormData] = useState({
  groupName: '',
  description: ''
});
const [groupFormErrors, setGroupFormErrors] = useState({
  groupName: '',
  description: ''
});
const [isSubmittingGroup, setIsSubmittingGroup] = useState(false);
const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
  fetchStudyGroups();
}, []);

 const navigate = useNavigate();

const fetchStudyGroups = async () => {
  try {
    const { data } = await getStudygroupDetails();
    setStudyGroups(data.studyGroups || []);
    console.log('Study groups loaded:', data.studyGroups);
  } catch (err) {
    console.error('Error fetching study groups:', err);
  }
};

  // Track initial form state
  useEffect(() => {
    if (!initialFormData && defineOptions.length > 0) {
      setInitialFormData(formData);
    }
  }, [defineOptions.length, formData, initialFormData]);

  // Detect form changes
  useEffect(() => {
    if (!initialFormData) return;

    const hasChanged =
      formData.studyName !== initialFormData.studyName ||
      formData.protocolId !== initialFormData.protocolId ||
      formData.studyDescription !== initialFormData.studyDescription ||
      formData.selectStudy?.id !== initialFormData.selectStudy?.id ||
      formData.defineStandard?.id !== initialFormData.defineStandard?.id ||
      formData.cdiscStandard?.id !== initialFormData.cdiscStandard?.id ||
      formData.standardVersion?.id !== initialFormData.standardVersion?.id ||
      formData.medDRA?.id !== initialFormData.medDRA?.id ||
      formData.whoDD?.id !== initialFormData.whoDD?.id ||
      formData.snomed?.id !== initialFormData.snomed?.id ||
      formData.loinc?.id !== initialFormData.loinc?.id ||
      formData.unii?.id !== initialFormData.unii?.id ||
      formData.ndfRtMedRt?.id !== initialFormData.ndfRtMedRt?.id ||
      formData.ctName?.id !== initialFormData.ctName?.id ||
      formData.ctVersion?.id !== initialFormData.ctVersion?.id ||
      formData.aCRF !== initialFormData.aCRF ||
      formData.supplementDocs.length !== initialFormData.supplementDocs.length;

    setHasFormChanged(hasChanged);
  }, [formData, initialFormData]);

  // Validation function
  const validateForm = (): boolean => {
    const errors: Record<string, string> = {};

    if (!formData.selectStudy) {
      errors.selectStudy = 'Study group is required';
    }
    if (!formData.studyName?.trim()) {
      errors.studyName = 'Study name is required';
    }
    if (!formData.protocolId?.trim()) {
      errors.protocolId = 'Protocol ID is required';
    }
    if (!formData.defineStandard) {
      errors.defineStandard = 'Define standard is required';
    }
    if (!formData.cdiscStandard) {
      errors.cdiscStandard = 'CDISC standard is required';
    }
    if (!formData.standardVersion) {
      errors.standardVersion = 'Standard version is required';
    }
    if (!formData.medDRA) {
      errors.medDRA = 'MedDRA is required';
    }
    if (!formData.whoDD) {
      errors.whoDD = 'WHODD is required';
    }
    if (!formData.snomed) {
      errors.snomed = 'SNOMED is required';
    }
    if (!formData.loinc) {
      errors.loinc = 'LOINC version is required';
    }
    if (!formData.unii) {
      errors.unii = 'UNII version is required';
    }
    if (!formData.ndfRtMedRt) {
      errors.ndfRtMedRt = 'NDF-RT/MED-RT version is required';
    }
    if (!formData.ctName) {
      errors.ctName = 'CT name is required';
    }
    if (!formData.ctVersion) {
      errors.ctVersion = 'CT version is required';
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      showToast.error(firstError);
    }

    return Object.keys(errors).length === 0;
  };

  const clearError = (field: string) => {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    });
  };

  // File handlers
  const handleDeleteFileClick = (
    type: 'aCRF' | 'supplementDocs',
    file: File | null,
    index?: number
  ) => {
    setFileToDelete({ type, file, index });
    setIsDeleteModalOpen(true);
  };

    const handleConfirmDelete = async () => {
    if (!fileToDelete) return;

    if (fileToDelete.type === 'aCRF') {
      setFormData(prev => ({ ...prev, aCRF: null }));
    } else if (fileToDelete.type === 'supplementDocs' && fileToDelete.index !== undefined) {
      setFormData(prev => ({
        ...prev,
        supplementDocs: prev.supplementDocs.filter((_, i) => i !== fileToDelete.index)
      }));
    }
     try {
      await deleteFile(fileToDelete.file?.studyFileId, user?.userId);
      setIsDeleteModalOpen(false);
      setFileToDelete(null);
      showToast.success('File deleted successfully');
    } catch (error) {
      showToast.error('Failed to delete file');
    }
  };

    const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
    setFileToDelete(null);
  };

    const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };

  const getFileIcon = (file: string | File | { fileName?: string; name?: string } | undefined) => {
    let name: string | undefined;
    console.log("file", file);
    console.log("typeof file", typeof file);
    
    if (typeof file === 'string') {
      name = file;
    } else if (file instanceof File) {
      name = file.name;
    } else if (file && (file.fileName || file.name)) {
      name = file.fileName || file.name;
    }
    
    if (!name) return null;
    
    console.log("filename", name);
    const ext = name.split('.').pop()?.toLowerCase();

    if (['pdf'].includes(ext || '')) {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#E53E3E" strokeWidth="2" />
          <path d="M14 2v6h6M9 13h6M9 17h6M9 9h1" stroke="#E53E3E" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    }
    if (['doc', 'docx'].includes(ext || '')) {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#2B6CB0" strokeWidth="2" />
          <path d="M14 2v6h6M9 13h6M9 17h6M9 9h1" stroke="#2B6CB0" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    }
    if (['xls', 'xlsx'].includes(ext || '')) {
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#38A169" strokeWidth="2" />
          <path d="M14 2v6h6M9 13h6M9 17h6M9 9h1" stroke="#38A169" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    }
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" stroke="currentColor" strokeWidth="2" />
        <path d="M13 2v7h7" stroke="currentColor" strokeWidth="2" />
      </svg>
    );
  };



const handleOpenModal = () => {
  setIsModalOpen(true);
  resetGroupForm();
};

const handleCloseModal = () => {
  setIsModalOpen(false);
  resetGroupForm();
};

const resetGroupForm = () => {
  setGroupFormData({ groupName: '', description: '' });
  setGroupFormErrors({ groupName: '', description: '' });
};

const validateGroupForm = () => {
  const errors = { groupName: '', description: '' };
  let isValid = true;

  if (!groupFormData.groupName.trim()) {
    errors.groupName = 'Group name is required';
    isValid = false;
  }

  if (!groupFormData.description.trim()) {
    errors.description = 'Description is required';
    isValid = false;
  }

  setGroupFormErrors(errors);
  return isValid;
};

const handleGroupSubmit = async () => {
  if (!validateGroupForm()) return;
  setIsSubmitting(true);
  setIsSubmittingGroup(true);
  try {
    const payload = {
      groupName: groupFormData.groupName,
      description: groupFormData.description,
      active: true // Hardcoded as per API requirement
    };

    await createStudyGroup(payload);
    await fetchStudyGroups();
    handleCloseModal();
    setTimeout(() => {
  setIsSubmitting(false);
}, 500);

    console.log('Study group updated successfully');
  } catch (err) {
    console.error('Error updating study group:', err);
    setGroupFormErrors(prev => ({
      ...prev,
      groupName: err.response?.data?.message || 'Failed to update study group'
    }));
  } finally {
    setIsSubmittingGroup(false);
  }
};

  const handleInputChange = (field: keyof StudyFormData, value: string) => {
    clearError(field);

    if (field === 'selectStudy') {
      const option = studyGroups.find(group => String(group.id) === value);
      setFormData(prev => ({
        ...prev,
        [field]: option ? { id: option.id, value: String(option.id), label: option.groupName } : null
      }));
    } else if (field === 'defineStandard') {
      const option = defineOptions.find(opt => (opt.referenceKey || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'cdiscStandard') {
      const option = cdiscOptions.find(opt => (opt.referenceKey || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'standardVersion') {
      const option = standardVersionOptions.find(opt => (opt.versionCode || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'medDRA') {
      const option = meddraOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'whoDD') {
      const option = whoddOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'snomed') {
      const option = snomedOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'loinc') {
      const option = loincOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'unii') {
      const option = uniiOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'ndfRtMedRt') {
      const option = ndfRtMedRtOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'ctName') {
      const option = ctNameOptions.find(opt => (opt.referenceKey || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else if (field === 'ctVersion') {
      const option = ctVersionOptions.find(opt => (opt.version || '') === value);
      setFormData(prev => ({ ...prev, [field]: option || null }));
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }

    if (field === 'cdiscStandard' && value) {
      fetchStandardVersions(value);
    }
    if (field === 'ctName' && value) {
      fetchCTVersions(value);
    }
  };

  // Function to populate formData from study data
  const populateFormDataFromStudy = (studyData: any) => {
    // Find corresponding dropdown options
    const selectedStudy = studyGroups.find(group => group.groupName === studyData.studyGroup);
    const defineStandardOption = defineOptions.find(opt => opt.referenceKey === studyData.defineStandard);
    const cdiscStandardOption = cdiscOptions.find(opt => opt.referenceKey === studyData.cdiscStandard);
    const standardVersionOption = standardVersionOptions.find(opt => opt.versionCode === studyData.cdiscVersion);
    const meddraOption = meddraOptions.find(opt => opt.version === studyData.meddraVersion);
    const whoddOption = whoddOptions.find(opt => opt.version === studyData.whoVersion);
    const snomedOption = snomedOptions.find(opt => opt.version === studyData.snomedVersion);
    const ctNameOption = ctNameOptions.find(opt => opt.referenceKey === studyData.ctName);
    const ctVersionOption = ctVersionOptions.find(opt => opt.version === studyData.ctVersion);
    const loincOption = loincOptions.find(opt => opt.version === studyData.loincVersion);
    const uniiOption = uniiOptions.find(opt => opt.version === studyData.uniiVersion);
    const ndfRtMedRtOption = ndfRtMedRtOptions.find(opt => opt.version === studyData.ndfrtMedrtVersion);

    // Extract file attachments
    let aCRFFile = null;
    let supplementDocsFiles = [];
    
    if (studyData.attachments) {
      // Find ACRF file from supporting files
      if (studyData.attachments.supportingFiles) {
        aCRFFile = studyData.attachments.supportingFiles.find((file: any) => file.fileType === 'ACRF') || null;
        
        // Get non-ACRF files as supplement docs
        supplementDocsFiles = studyData.attachments.supportingFiles.filter((file: any) => file.fileType === 'ATTACHMENTS');
      }
    }

    setFormData({
      selectStudy: selectedStudy ? { id: selectedStudy.id, label: selectedStudy.groupName } : null,
      studyName: studyData.studyName || '',
      studyCode: studyData.studyCode || '',
      protocolId: studyData.protocolId || '',
      studyDescription: studyData.studyDescription || '',
      status: studyData.status || '',
      indication: studyData.indication || '',
      studyVersionId: studyData.studyVersionId,
      userName: studyData.userName || '',
      defineStandard: defineStandardOption || null,
      cdiscStandard: cdiscStandardOption || null,
      standardVersion: standardVersionOption || null,
      medDRA: meddraOption || null,
      whoDD: whoddOption || null,
      snomed: snomedOption || null,
      ctName: ctNameOption || null,
      ctVersion: ctVersionOption || null,
      loinc: loincOption || null,
      unii: uniiOption || null,
      ndfRtMedRt: ndfRtMedRtOption || null,
      aCRF: aCRFFile,
      supplementDocs: supplementDocsFiles,
      attachments: studyData.attachments,
    });

    // Fetch dependent dropdown values after setting form data
    if (studyData.cdiscStandard) {
      fetchStandardVersions(studyData.cdiscStandard, studyData);
    }
    if (studyData.ctName) {
      fetchCTVersions(studyData.ctName, studyData);
    }
  };

  useEffect(() => {
    console.log("formData", formData);
  }, [formData]);

  // Fetch study data - simplified approach
  useEffect(() => {
    const populateStudy = async () => {
      // if (location.state?.study) {
        // console.log("Loading study from location.state");
        // populateFormDataFromStudy(location.state.study);
        // setLoading(false);
      // } else
         if (studyId) {
        try {
          setLoading(true);
          const response = await getStudyByStudyId(studyId);
          populateFormDataFromStudy(response.data);
        } catch (err) {
          console.error('Error fetching study:', err);
          setError('Failed to load study details');
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    // Only populate after essential dropdown options are loaded
    if (defineOptions.length > 0 && cdiscOptions.length > 0 && studyGroups.length > 0) {
      populateStudy();
    }
  }, [studyId, location.state?.study, defineOptions.length, cdiscOptions.length, studyGroups.length]);


   const handleRefresh = () => {
    window.location.reload();
  };

  // Fetch all dropdown values on mount
  useEffect(() => {
    setLoading(true);
    const fetchAllDropdowns = async () => {
      try {
        const [
          defineRes,
          cdiscRes,
          allDictRes,
          ctNameRes
        ] = await Promise.all([
          getDefineDropdownValues(),
          getCDISCStandardDropdownValues(),
          getDropdownValues(),
          getCTNameDropdownValues(),
        ]);

        setDefineOptions(defineRes.data.standardDetails || []);
        setCdiscOptions(cdiscRes.data.standardDetails || []);
        
        const allDictData = allDictRes.data;
        setWhoddOptions(allDictData.WHODD || []);
        setSnomedOptions(allDictData.SNOMED || []);
        setMeddraOptions(allDictData.MEDDRA || []);
        setUniiOptions(allDictData.UNII || []);
        setLoincOptions(allDictData.LOINC || []);
       setNdfRtMedRtOptions(allDictData.NDFRT_MEDRT  || []);

        // setNdfRtMedRtOptions(allDictData["NDFRT_MEDRT "] || []);
        
        setCtNameOptions(ctNameRes.data.standardDetails || []);

        console.log('Dropdown values loaded:', {
          define: defineRes.data,
          cdisc: cdiscRes.data,
          allDict: allDictData,
          ctNames: ctNameRes.data
        });
      } catch (err) {
        console.error('Error fetching dropdown values:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllDropdowns();
  }, []);

  // Fetch standard versions based on selected CDISC standard
  const fetchStandardVersions = async (cdiscStandard: string, studyData?: any) => {
    setIsLoadingStandardVersions(true);
    try {
      const response = await getCDISCStdVersionDropdownValues(cdiscStandard);
      console.log('Raw API response for standard versions:', response.data);
      const versions = response.data.sdtmigVersions || 
                      response.data.adamVersions || 
                      response.data.sendingVersions || 
                      [];
      setStandardVersionOptions(versions);
      console.log('Standard versions loaded:', versions);
      
      // Auto-select version if studyData is provided
      if (studyData?.cdiscVersion) {
        const selectedVersion = versions.find((opt: any) => opt.versionDisplay === studyData.cdiscVersion);
        if (selectedVersion) {
          setFormData(prev => ({ ...prev, standardVersion: selectedVersion }));
        }
      }
    } catch (err) {
      console.error('Error fetching standard versions:', err);
      setStandardVersionOptions([]);
    } finally {
      setIsLoadingStandardVersions(false);
    }
  };

  // Fetch CT versions based on selected CT name
  const fetchCTVersions = async (ctName: string, studyData?: any) => {
    setIsLoadingCTVersions(true);
    try {
      const response = await getCTNameVersionDropdownValues(ctName);
      console.log('Raw API response for CT versions:', response.data);
      const versions = response.data.versions || [];
      setCtVersionOptions(versions);
      console.log('CT versions loaded:', versions);
      
      // Auto-select version if studyData is provided
      if (studyData?.ctVersion) {
        const selectedVersion = versions.find((opt: any) => opt.packageName === studyData.ctVersion);
        if (selectedVersion) {
          setFormData(prev => ({ ...prev, ctVersion: selectedVersion }));
        }
      }
    } catch (err) {
      console.error('Error fetching CT versions:', err);
      setCtVersionOptions([]);
    } finally {
      setIsLoadingCTVersions(false);
    }
  };

const handleFileChange = (field: 'aCRF' | 'supplementDocs', files: FileList | null) => {
  if (field === 'aCRF') {
    // Replace with new file
    setFormData(prev => ({ ...prev, [field]: files?.[0] || null }));
  } else {
    // Add new files to existing ones
    if (files && files.length > 0) {
      const newFiles = Array.from(files);
      setFormData(prev => ({ 
        ...prev, 
        [field]: [...prev.supplementDocs, ...newFiles]
      }));
    }
  }
};

const handleSubmit = async () => {
  if (!validateForm()) {
    return;
  }

  try {
    const formDataToSend = new FormData();
    
    const currentStudyId = studyId || location.state?.study?.studyId;
    
    const metadata = {
      userId: user?.userId || 1,
      studyName: formData.studyName,
      protocolId: formData.protocolId,
      studyDescription: formData.studyDescription,
      studyGroupId: formData.selectStudy?.id || 1,
      defineStandard: formData.defineStandard?.referenceValue || formData.defineStandard?.referenceKey || '',
      cdiscStandard: formData.cdiscStandard?.referenceValue || formData.cdiscStandard?.referenceKey || '',
      versionStandard: formData.standardVersion?.versionDisplay || formData.standardVersion?.versionCode || '',
      meddraDictionary: formData.medDRA?.version || '',
      whoDictionary: formData.whoDD?.version || '',
      snomedDictionary: formData.snomed?.version || '',
      loincDictionary: formData.loinc?.version || '',
      uniiDictionary: formData.unii?.version || '',
      ndfrtMedrtDictionary: formData.ndfRtMedRt?.version || '',
      ctName: formData.ctName?.referenceValue || formData.ctName?.referenceKey || '',
      ctVersion: formData.ctVersion?.packageName || '',
      createdBy: user?.userName || ''
    };
    
    const metadataBlob = new Blob([JSON.stringify(metadata)], { type: 'application/json' });
    formDataToSend.append('metadata', metadataBlob);
    
    // ONLY append if it's a File instance (newly uploaded)
    if (formData.aCRF && formData.aCRF instanceof File) {
      formDataToSend.append('crfDocument', formData.aCRF);
    }
    
    // ONLY append File instances (newly uploaded)
    if (formData.supplementDocs && formData.supplementDocs.length > 0) {
      formData.supplementDocs.forEach((file: any) => {
        if (file instanceof File) {
          formDataToSend.append('supportingDocs', file);
        }
      });
    }

    setIsSubmitting(true);
    
    const response = await updateStudy(formDataToSend, currentStudyId);
    
    console.log('Study updated successfully:', response.data);
    
    if (response.status === 200) {
      showToast.success('Study updated successfully');
      setTimeout(() => {
        setIsSubmitting(false);
      }, 500);

      navigate('/defineui/assigned-studies');
    }
  } catch (error) {
    console.error('Error updating study:', error);
    showToast.error('Error updating study');
    setIsSubmitting(false);
  }
};
  const handleReset = () => {
    setFormData({
      selectStudy: null,
      studyName: '',
      protocolId: '',
      studyDescription: '',
      defineStandard: null,
      cdiscStandard: null,
      standardVersion: null,
      medDRA: null,
      whoDD: null,
      snomed: null,
      loinc: null,
      unii: null,
      ndfRtMedRt: null,
      ctName: null,
      ctVersion: null,
      aCRF: null,
      supplementDocs: [],
    });
    setStandardVersionOptions([]);
    setCtVersionOptions([]);
    setFormErrors({});
    setHasFormChanged(false);
    setInitialFormData(null);
  };

  const handleCancel = () => {
    handleReset();
     navigate('/defineui/assigned-studies');
  };


   const handleContinue = () => {
     window.location.href = '/defineui/xptfileupload?studyId=' + studyId;
   };


  if (loading) {
      return (
        <PageLoader message="Loading study configuration..." />
      );
    }
  
    if (error) {
     return(
      <ErrorPage title='Error Loading Study Configuration' message={error}  onRetry={handleRefresh} />
      );
    }
      const userPermissions = {
    canCreateStudy: true,
    canViewDefineFiles: true,
    canUploadDocuments: true,
    canViewDefinePreview: true,
    canAccessIssueManagement: true,
    canViewProgressCharts: true,
  };
  

  return (
    <>

      <PageHeader
        title="Edit Study"
        showRefresh={false}
        showCreateStudy={true}
        showDefineFiles={true}
        showUploadDocuments={true}
        showDefinePreview={true}
        showIssueManagement={true}
        showProgressCharts={true}
        selectedStudyId={studyId}
        permissions={userPermissions}
        onCreateStudy={() => {
          console.log('Create new study');
          // navigate('/defineui/create-study');
        }}
        onDefineFiles={() => {
          console.log('View define files - opens as tab next to study configuration');
          // Open define files tab/page
        }}
        onUploadDocuments={() => {
          if (studyId) {
            console.log('Upload documents for study:', studyId);
            // Open upload modal or navigate to upload page
          }
        }}
        onDefinePreview={() => {
          if (studyId) {
            console.log('View latest define.xml preview (read-only):', studyId);
            // navigate(`/defineui/define-preview/${selectedStudy}`);
          }
        }}
        onIssueManagement={() => {
          if (studyId) {
            console.log('Navigate to issue management for study:', studyId);
            // navigate(`/defineui/issues/${selectedStudy}`);
          }
        }}
        onProgressCharts={() => {
          if (studyId) {
            console.log('View progress charts for study:', studyId);
            // navigate(`/defineui/charts/${selectedStudy}`);
          }
        }}
      />
    <div className={styles.studyConfigContainer}>
      {/* Header with Tabs */}
      

      {/* <div className={styles.header}>
        <div className={styles.tabContainer}>
          <button
            className={`${styles.tab} ${activeTab === 'select' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('select')}
          >
            Select Study
          </button>
          <button
            className={`${styles.tab} ${activeTab === 'create' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('create')}
          >
            Create Study
          </button>
        </div>

        {/* Action Buttons 
        <div className={styles.actionButtons}>
          <button className={styles.iconButton} title="Download">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <button className={styles.iconButton} title="Upload">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <button className={styles.iconButton} title="Refresh">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M1 4v6h6M23 20v-6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <button className={styles.iconButton} title="View">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
          <button className={styles.iconButton} title="Settings">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" stroke="currentColor" strokeWidth="2"/>
              <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>
      </div> */}

      {/* Form Content */}
      <div className={styles.formContent}>
        {/* Study Details Section */}
       <section className={styles.section}>
  <div className={styles.sectionHeader}>
    <h2 className={styles.sectionTitle}>Study Details</h2>

      {/* <button className={styles.createGroupButton} onClick={handleOpenModal}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 5v14M5 12h14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        Add Study Group
      </button> */}

  </div>



 <div className={styles.selectStudyRow}>
   <div className={styles.formGroup}>
      <label className={styles.label}>Select Study<span className={styles.required}>*</span></label>
      <Dropdown
        options={studyGroups.map(group => ({
          value: String(group.id),
          label: group.groupName,
        }))}
        value={formData.selectStudy ? String(formData.selectStudy.id) : ''}
        onChange={value => handleInputChange('selectStudy', value)}
        placeholder="Select Study Group"
      />
      {formErrors.selectStudy && (
                        <span className={styles.errorText}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                            <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                          {formErrors.selectStudy}
                        </span>
                      )}
    </div>
    
    <button 
      className={styles.createGroupButtonInline} 
      onClick={handleOpenModal}
      title="Add Study Group"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 5v14M5 12h14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  </div>

  {/* Rest of study details form fields... */}

  <div className={styles.formRow}>
    <div className={styles.formGroup}>
      <label className={styles.label}>
        Study Name<span className={styles.required}>*</span>
      </label>
      <input
        type="text"
        className={styles.input}
        placeholder="Enter your Text"
        value={formData.studyName}
        onChange={e => handleInputChange('studyName', e.target.value)}
        disabled={isSubmitting}
      />
      {formErrors.studyName && (
                        <span className={styles.errorText}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                            <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                          {formErrors.studyName}
                        </span>
                      )}
    </div>

    <div className={styles.formGroup}>
      <label className={styles.label}>
        Protocol ID<span className={styles.required}>*</span>
      </label>
      <input
        type="text"
        className={styles.input}
        placeholder="Enter your Text"
        value={formData.protocolId}
        onChange={e => handleInputChange('protocolId', e.target.value)}
         disabled={isSubmitting}
      />
           {formErrors.protocolId && (
                        <span className={styles.errorText}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                            <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                          {formErrors.protocolId}
                        </span>
                      )}
    </div>

    <div className={styles.formGroup}>
      <label className={styles.label}>Study Description</label>
      <textarea
        className={styles.textarea}
        placeholder="Enter your Text"
        value={formData.studyDescription}
        onChange={e => handleInputChange('studyDescription', e.target.value)}
        rows={3}
        disabled={isSubmitting}
      />
    </div>
  </div>
</section>







<Modal
  isOpen={isModalOpen}
  onClose={handleCloseModal}
  title="Create Study Group"
>
  <div className={styles.modalForm}>
    <div className={styles.formGroup}>
      <label className={styles.label}>
        Group Name<span className={styles.required}>*</span>
      </label>

      <input
        type="text"
        className={`${styles.input} ${
          groupFormErrors.groupName ? styles.error : ""
        }`}
        placeholder="Enter group name"
        value={groupFormData.groupName}
        onChange={(e) =>
          setGroupFormData((prev) => ({
            ...prev,
            groupName: e.target.value,
          }))
        }
      />

      {groupFormErrors.groupName && (
        <span className={styles.errorText}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M12 8v4M12 16h.01"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          {groupFormErrors.groupName}
        </span>
      )}
    </div>

    <div className={styles.formGroup}>
      <label className={styles.label}>
        Description<span className={styles.required}>*</span>
      </label>

      <textarea
        className={`${styles.textarea} ${
          groupFormErrors.description ? styles.error : ""
        }`}
        placeholder="Enter group description"
        value={groupFormData.description}
        onChange={(e) =>
          setGroupFormData((prev) => ({
            ...prev,
            description: e.target.value,
          }))
        }
        rows={4}
      />

      {groupFormErrors.description && (
        <span className={styles.errorText}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M12 8v4M12 16h.01"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          {groupFormErrors.description}
        </span>
      )}
    </div>

    <div className={styles.modalFooter}>
      <button
        className={`${styles.submitButton} ${
          isSubmittingGroup ? styles.loading : ""
        }`}
        onClick={handleGroupSubmit}
        disabled={isSubmittingGroup}
      >
        Create Group
      </button>

      <button
        className={styles.cancelButton}
        onClick={handleCloseModal}
        disabled={isSubmittingGroup}
      >
        Cancel
      </button>
    </div>
  </div>
</Modal>




        {/* Standard Details Section */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Standard Details</h2>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label}>
                Select Define Standard<span className={styles.required}>*</span>
              </label>
              <Dropdown
                options={defineOptions.map(opt => ({
                  value: opt.referenceKey || '',
                  label: opt.referenceValue || ''
                }))}
                value={formData.defineStandard?.referenceKey || ''}
                onChange={(value) => handleInputChange('defineStandard', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
                 {formErrors.defineStandard && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.defineStandard}
                                </span>
                              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                CDISC Standard<span className={styles.required}>*</span>
              </label>
              <Dropdown
                options={cdiscOptions.map(opt => ({
                  value: opt.referenceKey || '',
                  label: opt.referenceValue || ''
                }))}
                value={formData.cdiscStandard?.referenceKey || ''}
                onChange={(value) => handleInputChange('cdiscStandard', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
                 {formErrors.cdiscStandard && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.cdiscStandard}
                                </span>
                              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                Standard Version<span className={styles.required}>*</span>
                {isLoadingStandardVersions && (
                  <FieldLoader style={{ marginLeft: '8px' }} />
                )}
              </label>
              <Dropdown
                options={standardVersionOptions.map(opt => ({
                  value: opt.versionCode || '',
                  label: opt.versionDisplay || ''
                }))}
                value={formData.standardVersion?.versionCode || ''}
                onChange={(value) => handleInputChange('standardVersion', value)}
                placeholder="Select"
                disabled={!formData.cdiscStandard || standardVersionOptions.length === 0 || isLoadingStandardVersions || isSubmitting}
              />
                 {formErrors.standardVersion && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.standardVersion}
                                </span>
                              )}
            </div>
          </div>
        </section>

        {/* Dictionaries Section */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Dictionaries</h2>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label}>MedDRA<span className={styles.required}>*</span></label>
              <Dropdown
                options={meddraOptions.map(opt => ({
                  value: opt.version || '',
                  label: opt.version || ''
                }))}
                value={formData.medDRA?.version || ''}
                onChange={(value) => handleInputChange('medDRA', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
                {formErrors.medDRA && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.medDRA}
                                </span>
                              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>WHODD<span className={styles.required}>*</span></label>
              <Dropdown
                options={whoddOptions.map(opt => ({
                  value: opt.version || '',
                  label: opt.version || ''
                }))}
                value={formData.whoDD?.version || ''}
                onChange={(value) => handleInputChange('whoDD', value)}
                placeholder="Select"
                disabled={isSubmitting}/>
                {formErrors.whoDD && (
                                  <span className={styles.errorText}>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                      <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                    {formErrors.whoDD}
                                  </span>
                                )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>SNOMED<span className={styles.required}>*</span></label>
              <Dropdown
                options={snomedOptions.map(opt => ({
                  value: opt.version || '',
                  label: opt.version || ''
                }))}
                value={formData.snomed?.version || ''}
                onChange={(value) => handleInputChange('snomed', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
                 {formErrors.snomed && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.snomed}
                                </span>
                              )}
            </div>
          </div>
            <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label}>LOINC Version<span className={styles.required}>*</span></label>
              <Dropdown
                options={loincOptions.map(opt => ({
                  value: opt.version || '',
                  label: opt.version || ''
                }))}
                value={formData.loinc?.version || ''}
                onChange={(value) => handleInputChange('loinc', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
                  {formErrors.loinc && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.loinc}
                                </span>
                              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>UNII Version<span className={styles.required}>*</span></label>
              <Dropdown
                options={uniiOptions.map(opt => ({
                  value: opt.version || '',
                  label: opt.version || ''
                }))}
                value={formData.unii?.version || ''}
                onChange={(value) => handleInputChange('unii', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
                {formErrors.unii && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.unii}
                                </span>
                              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>NDF-RT/MED-RT Version<span className={styles.required}>*</span></label>
              <Dropdown
                options={ndfRtMedRtOptions.map(opt => ({
                  value: opt.version || '',
                  label: opt.version || ''
                }))}
                value={formData.ndfRtMedRt?.version || ''}
                onChange={(value) => handleInputChange('ndfRtMedRt', value)}
                placeholder="Select"
                disabled={isSubmitting}
              />
              {formErrors.ndfRtMedRt && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.ndfRtMedRt}
                                </span>
                              )}
            </div>
          </div>
        </section>

        {/* Controlled Terminologies Section */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Controlled Terminologies</h2>
          
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label className={styles.label}>
                CT Name<span className={styles.required}>*</span>
              </label>
              <Dropdown
                options={ctNameOptions.map(opt => ({
                  value: opt.referenceKey || '',
                  label: opt.referenceValue?.toUpperCase() || ''
                }))}
                value={formData.ctName?.referenceKey || ''}
                onChange={(value) => handleInputChange('ctName', value)}
                placeholder="Select"
                disabled= {isSubmitting}
              />
                       {formErrors.ctName && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.ctName}
                                </span>
                              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                CT Version<span className={styles.required}>*</span>
                {isLoadingCTVersions && (
                  <FieldLoader style={{ marginLeft: '8px' }} />
                )}
              </label>
              <Dropdown
                options={ctVersionOptions.map(opt => ({
                  value: opt.version || '',
                  label: `${opt.name}`
                }))}
                value={formData.ctVersion?.version || ''}
                onChange={(value) => handleInputChange('ctVersion', value)}
                placeholder="Select"
                disabled={!formData.ctName || ctVersionOptions.length === 0 || isLoadingCTVersions || isSubmitting}
              />
              {formErrors.ctVersion && (
                                <span className={styles.errorText}>
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                    <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                  {formErrors.ctVersion}
                                </span>
                              )}
            </div>
          </div>
        </section>

        {/* Attachments Section */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Attachments</h2>
          
          <div className={styles.formRow}>
                <div className={styles.formGroup}>
                           <label className={styles.label}>Attach aCRF</label>
           
                           {!formData.aCRF && (
                             <div className={styles.fileInput}>
                               <input
                                 type="file"
                                 id="aCRF"
                                 className={styles.fileInputHidden}
                                 onChange={e => handleFileChange('aCRF', e.target.files)}
                                 disabled={isSubmitting}
                               />
                               <label htmlFor="aCRF" className={styles.fileInputLabel}>
                                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                   <path
                                     d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"
                                     stroke="currentColor"
                                     strokeWidth="2"
                                   />
                                   <path d="M13 2v7h7" stroke="currentColor" strokeWidth="2" />
                                 </svg>
                                 <span>Select File</span>
                               </label>
                             </div>
                           )}
           
                           {formData.aCRF && (
                             <div className={styles.fileList}>
                               <div className={styles.fileItem}>
                                 <div className={styles.fileIcon}>{getFileIcon(formData.aCRF.fileName || formData.aCRF.name)}</div>
                                 <div className={styles.fileInfo}>
                                   <div className={styles.fileName}>{formData.aCRF.fileName || formData.aCRF.name}</div>
                                   {/* <div className={styles.fileSize}>{formatFileSize(formData.aCRF.size)}</div> */}
                                 </div>
                                 <button
                                   type="button"
                                   className={styles.deleteFileButton}
                                   onClick={() => handleDeleteFileClick('aCRF', formData.aCRF)}
                                   disabled={isSubmitting}
                                   title="Remove file"
                                 >
                                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                     <path
                                       d="M18 6L6 18M6 6l12 12"
                                       stroke="currentColor"
                                       strokeWidth="2"
                                       strokeLinecap="round"
                                     />
                                   </svg>
                                 </button>
                               </div>
                             </div>
                           )}
                         </div>

            <div className={styles.formGroup}>
                          <label className={styles.label}>Attach Supplement Documents</label>
          
                          <div className={styles.fileInput}>
                            <input
                              type="file"
                              id="supplementDocs"
                              className={styles.fileInputHidden}
                              multiple
                              onChange={e => handleFileChange('supplementDocs', e.target.files)}
                              disabled={isSubmitting}
                            />
                            <label htmlFor="supplementDocs" className={styles.fileInputLabel}>
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path
                                  d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                />
                                <path d="M13 2v7h7" stroke="currentColor" strokeWidth="2" />
                              </svg>
                              <span>
                                {formData.supplementDocs.length > 0
                                  ? `Add More Files (${formData.supplementDocs.length} selected)`
                                  : 'Select Files'}
                              </span>
                            </label>
                          </div>
          
                          {formData.supplementDocs.length > 0 && (
                            <div className={styles.fileList}>
                              {formData.supplementDocs.map((file, index) => (
                                <div key={index} className={styles.fileItem}>
                                  <div className={styles.fileIcon}>{getFileIcon(file.fileName || file.name)}</div>
                                  <div className={styles.fileInfo}>
                                    <div className={styles.fileName}>{file.fileName || file.name}</div>
                                    {/* <div className={styles.fileSize}>{formatFileSize(file.size)}</div> */}
                                  </div>
                                  <button
                                    type="button"
                                    className={styles.deleteFileButton}
                                    onClick={() => handleDeleteFileClick('supplementDocs', file, index)}
                                    disabled={isSubmitting}
                                    title="Remove file"
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                      <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
          </div>
        </section>
      </div>

      {/* Footer Buttons */}
      <div className={styles.footer}>
       <button
                   className={styles.submitButton}
                   onClick={handleSubmit}
                   disabled={isSubmitting || !hasFormChanged}
                   title={!hasFormChanged ? 'Make changes to enable save' : 'Save changes'}
                 >
                   Save
                 </button>
        <button className={styles.resetButton} onClick={handleContinue} disabled={isSubmitting}>
          Continue
        </button>
        <button className={styles.cancelButton} onClick={handleCancel} disabled={isSubmitting}>
          Cancel
        </button>
      </div>
    </div>
    <SubmitLoader
  isVisible={isSubmitting}
  type="update"
  message="Updating Study Configuration..."
/>

 <Modal isOpen={isDeleteModalOpen} onClose={handleCancelDelete} title="Delete File">
        <div className={styles.deleteModalContent}>
          <div className={styles.deleteWarningIcon}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#E53E3E" strokeWidth="2" />
              <path d="M12 8v4M12 16h.01" stroke="#E53E3E" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>

          <h3 className={styles.deleteModalTitle}>Are you sure you want to delete this file?</h3>

          <p className={styles.deleteModalMessage}>{fileToDelete?.file?.name}</p>

          <p className={styles.deleteModalWarning}>This action cannot be undone.</p>

          <div className={styles.deleteModalActions}>
            <button className={styles.deleteModalButton} onClick={handleConfirmDelete}>
              Delete
            </button>
            <button className={styles.cancelModalButton} onClick={handleCancelDelete}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UpdateStudyConfiguration;